import { Zap, Sparkles, Shuffle } from 'lucide-react';

// How a voice was created — driven by the entity `type` field returned by the cloned_voice
// API ('design' | 'mix' | absent = instant clone). Single source of truth for the
// label/verb/noun/icon/color so My Voices, the editor's Clones panel, etc. don't each
// hardcode their own copy of "Cloning…"/"Voice cloning failed"/etc.
export type VoiceCreationType = 'cloned' | 'design' | 'mix';

export interface VoiceTypeMeta {
    label: string; // e.g. 'Cloned' — badge text
    verb: string;  // e.g. 'Cloning' — in-progress copy ("Cloning your voice…")
    noun: string;  // e.g. 'clone' — failure copy ("Voice clone failed")
    Icon: any;
    color: string; // text color for badges/labels
    bg: string;    // background for full card badges (My Voices)
    badgeBg: string; // background for compact avatar-corner badges (Clones panel)
}

export const VOICE_TYPE_META: Record<VoiceCreationType, VoiceTypeMeta> = {
    cloned: { label: 'Cloned', verb: 'Cloning', noun: 'clone', Icon: Zap, color: '#B45309', bg: 'rgba(245,158,11,0.12)', badgeBg: '#F59E0B' },
    design: { label: 'Designed', verb: 'Designing', noun: 'design', Icon: Sparkles, color: '#4F46E5', bg: 'rgba(99,102,241,0.12)', badgeBg: '#6366F1' },
    mix: { label: 'Remixed', verb: 'Remixing', noun: 'remix', Icon: Shuffle, color: '#BE185D', bg: 'rgba(236,72,114,0.12)', badgeBg: '#EC4899' },
};

const VOICE_CREATION_TYPES = new Set<string>(['cloned', 'design', 'mix']);

export function getVoiceTypeMeta(type?: string | null): VoiceTypeMeta {
    if (type && VOICE_CREATION_TYPES.has(type)) return VOICE_TYPE_META[type as VoiceCreationType];
    return VOICE_TYPE_META.cloned;
}
